import { GoogleSheetsSyncPage, SyncType } from '../../components/GoogleSheetsSyncPage/GoogleSheetsSyncPage';
import { PageId } from '../../components/Sidebar/Sidebar';
import defaultSheets from '../../config/default_sheets';

const SalesmenSyncPage = () => {
  return (
    <GoogleSheetsSyncPage
      title="Sync Salesmen Data from Google Sheets"
      syncType={SyncType.Salesmen}
      pageId={PageId.Salesmen}
      defaultSheetUrl={defaultSheets.Salesmen.defaultSheetUrl}
      defaultRange={defaultSheets.Salesmen.defaultRange}
    />
  );
};

export default SalesmenSyncPage;
